'use strict';

const workerLogStates = ({ elmWithFilter }) => {
	return [
		{
			name: 'site.WorkerLog',
			url: '/workerLog',
			redirectTo: 'site.WorkerLog.Work'
		},
		{
			name: 'site.WorkerLog.Work.Item',
			url: '/:workId',
			redirectTo: 'site.WorkerLog.Work'
		},
		elmWithFilter({
			name: 'site.WorkerLog.Work',
			moduleName: 'NetworkLogs.Main',
			url: '/items?filter&view',
			pageTitle: 'listings.navigation.networks_log',
			requiredPermission: 'permission/location.view',
			argsResolver: [
				'$stateParams',
				'auth',
				'pmtFilterService',
				async ($stateParams, auth, pmtFilterService) => {
					return auth.getUser($stateParams.site).then(async user => {
						return {
							analytics: user.selectedSite?.analytics,
							initialFilter: await pmtFilterService.parseFilter($stateParams),
							timezoneOffset: new Date().getTimezoneOffset()
						};
					});
				}
			]
		})
	];
};

module.exports = {
	workerLogStates
};
